const Modernizr = window.Modernizr;

export const loadImage = (src) => {
	return new Promise((resolve, reject) => {
		const img = new Image();
		img.onload = () => {
			resolve(img);
		};
		img.onerror = () => {
			reject();
		};
		img.src = src;
	});
};

export const loadFullSizeImage = ({ img, classNames = []}) => {
	return new Promise((resolve, reject) => {
		const $img = img;
		const alt = $img.attr('alt');
		const src = $img.attr('data-src');
		loadImage(src)
			.then(() => {
				if (Modernizr.objectfit) {
					$img.attr('src', src);
				} else {
					const $div = $(`<div role="img" aria-label="${alt}" style="background-image:url('${src}')"></div>`);
					if (Array.isArray(classNames)) {
						$div.addClass(classNames.join(' '));
					}
					$img.replaceWith($div);
				}
				resolve();
			})
			.catch((err) => {
				reject(err);
			});
	});
};

export const vimeoIdFromUrl = (vimeoUrl) => vimeoUrl.split('/').pop();
